import { createStorefrontApiClient } from "@shopify/storefront-api-client";

export default createStorefrontApiClient({
  storeDomain: process.env.GATSBY_SHOPIFY_STORE_URL,
  publicAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  apiVersion: '2025-04',
});
